import { render, staticRenderFns } from "./projectEditing.vue?vue&type=template&id=0a359fa6&scoped=true&"
import script from "./projectEditing.vue?vue&type=script&lang=js&"
export * from "./projectEditing.vue?vue&type=script&lang=js&"
import style0 from "./projectEditing.vue?vue&type=style&index=0&id=0a359fa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a359fa6",
  null
  
)

export default component.exports